import React, { type FC } from 'react';

export const EmptySearchIconSmall: FC = () => (
  <svg
    width="94"
    height="80"
    viewBox="0 0 94 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3239_9395)">
      <g clipPath="url(#clip1_3239_9395)">
        <path
          d="M87.8678 22.3071C83.4011 19.3859 76.2011 18.1245 67.6011 18.6556C59.6011 7.76764 45.4011 2.92117 32.9344 7.70125C20.4678 12.4813 13.7344 25.4274 15.8678 38.5726C9.33444 43.8838 5.00111 49.527 3.93444 54.5726C3.53444 56.4979 5.73444 58.0913 7.33444 56.9627C10.8011 54.3734 14.9344 51.7178 19.6011 49.0622C19.7344 48.9959 19.8678 48.9295 20.0011 48.8631C22.4678 61.8091 29.1344 72.4315 41.4011 74.3568C54.3344 76.3485 66.2678 68.4481 70.1344 53.9087L73.5344 51.5187C74.8678 50.5892 75.4678 48.9295 75.0011 47.4025C73.8011 43.6183 71.5344 36.6473 70.7344 33.527L70.6678 33.7261C70.3344 32.2656 69.8678 30.8714 69.2678 29.5436C70.4011 29.278 71.5344 29.0124 72.6011 28.7469C77.8678 27.5519 82.8011 26.6888 87.2011 26.2905C89.0678 26.0913 89.5344 23.4357 87.8678 22.3071Z"
          fill="#EAF0FA"
        />
        <path
          d="M32.867 7.56847C31.2003 9.29461 29.5337 15.6681 31.267 21.6432"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M32.4668 7.03734C38.2001 7.03734 47.9335 12.7469 50.7335 20.0498"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M33.6675 6.04149C32.3342 6.83817 32.4675 0 34.8675 0C37.2008 0 35.6675 4.91286 33.6675 6.04149Z"
          fill="#EAF0FA"
        />
        <path
          d="M31.6681 6.43983C33.1348 6.24066 30.8681 2.5892 28.8015 3.58506C26.6681 4.6473 29.6015 6.70539 31.6681 6.43983Z"
          fill="#EAF0FA"
        />
        <path
          d="M62.068 44.083C62.8412 44.083 63.468 43.4588 63.468 42.6888C63.468 41.9188 62.8412 41.2946 62.068 41.2946C61.2948 41.2946 60.668 41.9188 60.668 42.6888C60.668 43.4588 61.2948 44.083 62.068 44.083Z"
          fill="#031D44"
        />
        <path
          d="M38.5332 77.7427C40.6665 78.6722 42.7332 79.2033 42.7332 79.2033C43.9999 79.6017 45.3332 78.8714 45.7332 77.5436C46.1332 76.2822 45.3999 74.9544 44.0665 74.556L46.5999 75.2863C47.8665 75.6846 49.1999 74.9544 49.5999 73.6266C49.9999 72.3651 49.2665 71.0373 47.9332 70.639L50.7999 71.5021C52.0665 71.9004 53.3999 71.1701 53.7999 69.8423C54.1999 68.5145 53.4665 67.2531 52.1332 66.8548L39.3999 63.1369L46.4665 60.6141"
          stroke="#031D44"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M62.0669 59.751C71.5294 59.751 79.2003 52.112 79.2003 42.6888C79.2003 33.2656 71.5294 25.6266 62.0669 25.6266C52.6044 25.6266 44.9336 33.2656 44.9336 42.6888C44.9336 52.112 52.6044 59.751 62.0669 59.751Z"
          stroke="#031D44"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M49.8008 65.8589L53.8675 58.0913"
          stroke="#031D44"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M60.2674 63.7344C59.3341 65.5934 57.8008 66.4564 57.8008 66.4564"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_3239_9395">
        <rect width="94" height="80" fill="white" />
      </clipPath>
      <clipPath id="clip1_3239_9395">
        <rect
          width="93.3333"
          height="80"
          fill="white"
          transform="translate(0.333984)"
        />
      </clipPath>
    </defs>
  </svg>
);
